/* Oway Bespoke Ritual quiz — engine + UI.
   Product data: ritual-quiz-data.json (generated from docs/quiz-seed.json in the theme repo).
   Live price/image/availability: fetched per recommended product from /products/{handle}.js.
   Spec: docs/quiz-logic.md. */
(function () {
  'use strict';

  /* ------------------------------------------------ copy: questions -- */

  var HAIR_GOALS = [
    { v: 'frizz', l: 'Smooth, frizz-free hair', d: 'Calm, sleek lengths' },
    { v: 'hairloss', l: 'Thinning or hair loss', d: 'Fuller, stronger hair' },
    { v: 'curl_definition', l: 'Defined curls', d: 'Shaped, bouncy curls' },
    { v: 'volume', l: 'More volume', d: 'Lift from the roots' },
    { v: 'dryness', l: 'Hydration', d: 'For dry, thirsty hair' },
    { v: 'damage', l: 'Repair', d: 'After bleach, colour or heat' },
    { v: 'color_fade', l: 'Colour protection', d: 'Keep the colour vivid' },
    { v: 'tone', l: 'Tone correction', d: 'Cooler or warmer reflections' },
    { v: 'hold', l: 'Styling', d: 'Hold, texture or a lasting finish' },
    { v: 'shine', l: 'Shine', d: 'A light, glossy finish' },
    { v: 'scalp', l: 'Scalp comfort', d: 'Oil, flakes or irritation' }
  ];
  var FACE_GOALS = [
    { v: 'aging', l: 'Firmness and fine lines', d: 'Lifted, plumper skin' },
    { v: 'dark_spots', l: 'Dark spots', d: 'A more even tone' },
    { v: 'redness', l: 'Redness', d: 'Calm and comfort' },
    { v: 'breakouts', l: 'Breakouts', d: 'Clear, less congested skin' },
    { v: 'dullness', l: 'Dullness', d: 'Bring back the glow' },
    { v: 'eye_area', l: 'The eye area', d: 'Dark circles and puffiness' }
  ];
  var BODY_NEEDS = [
    { v: 'body_hydration', l: 'Hydration', d: 'Soft, supple skin' },
    { v: 'body_glow', l: 'Glow and silkiness', d: 'A satin finish' },
    { v: 'body_exfoliation', l: 'Gentle exfoliation', d: 'Smooth, polished skin' },
    { v: 'body_firming', l: 'Firming and toning', d: 'Tone and elasticity' },
    { v: 'hands', l: 'Hand care', d: 'For busy, dry hands' },
    { v: 'feet', l: 'Foot care', d: 'Soft, relieved feet' },
    { v: 'sun_protection', l: 'After-sun care', d: 'Calm sun-stressed skin' }
  ];
  /* optional questions carry a skip link above the grid, so nobody scrolls past 11 tiles to say no */
  var NO_SECOND = { v: 'none', l: 'No second goal' };

  /* The main goal drives the recommendation. The second goal only shapes what
     goes around it, and "none" keeps the ritual undiluted. */
  var QUESTIONS = [
    { id: 'area', title: 'What would you like to take care of?', type: 'single', options: [
      { v: 'hair', l: 'Hair and scalp', d: 'Wash, care and styling' },
      { v: 'face', l: 'Face', d: 'Cleanse, treat, moisturise' },
      { v: 'body', l: 'Body', d: 'Skin from the neck down' },
      { v: 'shave', l: 'Beard and shave', d: 'The grooming ritual' }
    ]},

    /* ---- hair ---- */
    { id: 'h_pattern', showIf: { area: 'hair' }, title: 'What is your natural hair type?', type: 'single', options: [
      { v: 'straight', l: 'Straight', d: 'No natural bend' },
      { v: 'wavy', l: 'Wavy', d: 'Loose bends and S shapes' },
      { v: 'curly', l: 'Curly', d: 'Defined springs and spirals' },
      { v: 'coily', l: 'Coily', d: 'Tight coils or zig zags' }
    ]},
    { id: 'h_goal1', showIf: { area: 'hair' }, title: 'What is your main hair goal?', sub: 'The one thing you most want to improve. We build the ritual around it.', type: 'single', options: HAIR_GOALS },
    { id: 'h_goal2', showIf: { area: 'hair' }, excludeAnswer: 'h_goal1', title: 'Is there a second goal?', sub: 'Optional. Your main goal always comes first.', type: 'single', skip: NO_SECOND, options: HAIR_GOALS },
    { id: 'h_strand', showIf: { area: 'hair', h_goals: ['frizz', 'curl_definition', 'volume', 'dryness', 'damage', 'hold', 'shine'] }, title: 'How thick is a single strand of your hair?', type: 'single', options: [
      { v: 'fine', l: 'Fine', d: 'Thin, easily flattened' },
      { v: 'medium', l: 'Medium', d: 'Neither fine nor thick' },
      { v: 'thick', l: 'Thick or coarse', d: 'Wide, strong strands' }
    ]},
    { id: 'h_weighed', showIf: { area: 'hair', h_goals: ['frizz', 'curl_definition', 'volume', 'dryness', 'damage', 'hold', 'shine'] }, title: 'Does your hair get weighed down easily?', type: 'single', options: [
      { v: 'yes', l: 'Yes', d: 'Most products flatten it' },
      { v: 'no', l: 'No', d: 'It handles product well' }
    ]},
    { id: 'h_scalp', showIf: { area: 'hair', h_goals: ['scalp'] }, title: 'What is your scalp like?', sub: 'Pick up to two.', type: 'multi', max: 2, options: [
      { v: 'balanced', l: 'Balanced', d: 'No complaints' },
      { v: 'oily', l: 'Oily', d: 'Flat or greasy fast' },
      { v: 'flaky', l: 'Dry or flaky', d: 'Visible flakes' },
      { v: 'sensitive', l: 'Itchy or sensitive', d: 'Easily irritated' },
      { v: 'sweat', l: 'I sweat a lot', d: 'Sport or training most days' },
      { v: 'shedding', l: 'Shedding or thinning', d: 'More hair in the brush lately' }
    ]},
    { id: 'h_flake_type', showIf: { area: 'hair', h_scalp: 'flaky' }, title: 'What do the flakes look like?', type: 'single', options: [
      { v: 'dry', l: 'Dry and powdery', d: 'Fine white dust, scalp feels tight' },
      { v: 'greasy', l: 'Larger and a little greasy', d: 'Usually with an oily scalp' }
    ]},
    { id: 'h_shed_scalp', showAny: [{ h_goals: 'hairloss' }, { h_scalp: 'shedding' }], showIf: { area: 'hair' }, title: 'Is your scalp sensitive?', sub: 'Often the case after pregnancy or stress. If yes, we choose a gentler formula.', type: 'single', options: [
      { v: 'sensitive', l: 'Yes', d: 'Sensitive, dry or reactive' },
      { v: 'normal', l: 'No', d: 'Normal to oily' }
    ]},
    { id: 'h_lengths', showIf: { area: 'hair', h_goals: ['frizz', 'dryness', 'damage', 'shine', 'curl_definition', 'color_fade'] }, title: 'How are your lengths and ends?', sub: 'Pick up to two.', type: 'multi', max: 2, options: [
      { v: 'healthy', l: 'Healthy', d: 'No real complaints' },
      { v: 'dry', l: 'Dry', d: 'Rough to the touch' },
      { v: 'damaged', l: 'Damaged', d: 'From colour, bleach or heat' },
      { v: 'split_ends', l: 'Split ends', d: 'Frayed, brittle tips' }
    ]},
    { id: 'h_porous', showIf: { area: 'hair', h_lengths: ['dry', 'damaged'] }, title: 'Does your hair soak up product fast but still feel dry?', type: 'single', options: [
      { v: 'yes', l: 'Yes', d: 'It absorbs everything quickly' },
      { v: 'no', l: 'Not really', d: 'Product sits on top for a while' }
    ]},
    { id: 'h_color', showIf: { area: 'hair', h_goals: ['color_fade', 'tone', 'frizz', 'damage', 'dryness'] }, title: 'Is your hair coloured or treated?', sub: 'Pick everything that applies.', type: 'multi', options: [
      { v: 'none', l: 'Natural, untreated', d: 'No colour or chemical services', solo: true },
      { v: 'colored', l: 'Coloured or highlighted', d: 'Balayage and gloss count too' },
      { v: 'cool', l: 'Blonde, silver or grey', d: 'Tends to turn yellow or brassy' },
      { v: 'warm', l: 'Golden or caramel', d: 'Warm tones worth keeping alive' },
      { v: 'keratin', l: 'Keratin or smoothing treatment', d: 'A salon smoothing service' }
    ]},
    { id: 'h_climate', showIf: { area: 'hair', h_goals: ['frizz', 'curl_definition'] }, title: 'What is the climate where you live?', sub: 'Humidity changes which formulas work best.', type: 'single', options: [
      { v: 'humid', l: 'Humid', d: 'Damp air most of the year' },
      { v: 'dry', l: 'Dry', d: 'Dry air, low humidity' },
      { v: 'mixed', l: 'Mixed', d: 'Changes with the seasons' }
    ]},
    { id: 'h_hold', showIf: { area: 'hair', h_goals: ['hold', 'curl_definition'] }, title: 'How much hold do you want?', type: 'single', options: [
      { v: '0', l: 'No styling products', d: 'Care only, I do not style my hair' },
      { v: '1', l: 'Barely there', d: 'Just guidance and texture' },
      { v: '2', l: 'Flexible', d: 'Shaped, but moves naturally' },
      { v: '3', l: 'Strong', d: 'Holds through the day' },
      { v: '4', l: 'Maximum', d: 'Locked in place' }
    ]},
    { id: 'h_finish', showIf: { area: 'hair', h_hold: ['1', '2', '3', '4'] }, title: 'What finish do you like?', type: 'single', options: [
      { v: 'invisible', l: 'Invisible', d: 'No trace of product' },
      { v: 'natural', l: 'Natural', d: 'Soft, true to your hair' },
      { v: 'matte', l: 'Matte', d: 'No shine at all' },
      { v: 'gloss', l: 'Glossy', d: 'Polished and shiny' }
    ]},
    { id: 'h_washfreq', showIf: { area: 'hair' }, title: 'How often do you wash your hair?', type: 'single', options: [
      { v: 'daily', l: 'Every day', d: 'Once a day or more' },
      { v: 'often', l: 'Every 2 to 3 days', d: 'The most common rhythm' },
      { v: 'weekly', l: 'Once or twice a week', d: 'Longer between washes' }
    ]},
    { id: 'h_prefs', showIf: { area: 'hair' }, title: 'Anything we should leave out?', sub: 'Optional. Pick what applies.', type: 'multi', skip: { v: 'none', l: 'Nothing to leave out, show me everything' }, options: [
      { v: 'fragrance_free', l: 'Fragrance-free only', d: 'No perfume in leave-on products' },
      { v: 'no_glycerin', l: 'No glycerin in leave-ins', d: 'My hair frizzes with it in humidity' },
      { v: 'no_silicone', l: 'No silicones', d: 'Plant-based finishes only' },
      { v: 'pregnancy', l: 'I am pregnant or breastfeeding', d: 'We keep it extra gentle' }
    ]},

    /* ---- face ---- */
    { id: 'f_skin', showIf: { area: 'face' }, title: 'What is your skin type?', type: 'single', options: [
      { v: 'dry', l: 'Dry', d: 'Tight after cleansing' },
      { v: 'oily', l: 'Oily', d: 'Shiny by midday' },
      { v: 'combo', l: 'Combination', d: 'Oily T-zone, drier cheeks' },
      { v: 'sensitive', l: 'Sensitive', d: 'Reacts easily, gets red' },
      { v: 'balanced', l: 'Balanced', d: 'No real complaints' }
    ]},
    { id: 'f_concern1', showIf: { area: 'face' }, title: 'What is your main skin goal?', sub: 'The one thing you most want to improve.', type: 'single', options: FACE_GOALS },
    { id: 'f_concern2', showIf: { area: 'face' }, excludeAnswer: 'f_concern1', title: 'Is there a second goal?', sub: 'Optional. Your main goal always comes first.', type: 'single', skip: NO_SECOND, options: FACE_GOALS },
    { id: 'f_ff', showIf: { area: 'face' }, title: 'Do you want fragrance-free products only?', type: 'single', options: [
      { v: 'yes', l: 'Yes', d: 'No perfume at all' },
      { v: 'no', l: 'Fragrance is fine', d: 'I enjoy a natural scent' }
    ]},

    /* ---- body ---- */
    { id: 'b_need1', showIf: { area: 'body' }, title: 'What does your skin need most?', type: 'single', options: BODY_NEEDS },
    { id: 'b_need2', showIf: { area: 'body' }, excludeAnswer: 'b_need1', title: 'Anything else?', sub: 'Optional. Your main need always comes first.', type: 'single', skip: { v: 'none', l: 'Nothing else' }, options: BODY_NEEDS },

    /* ---- shave ---- */
    { id: 's_beard', showIf: { area: 'shave' }, title: 'Do you have a beard?', type: 'single', options: [
      { v: 'yes', l: 'Yes', d: 'Beard care included' },
      { v: 'no', l: 'Clean shaven', d: 'Shave and skin care' }
    ]}
  ];

  /* main + second goal answers become the goal lists the engine works with */
  function withGoals(a) {
    var o = Object.assign({}, a);
    function pair(k1, k2, out) {
      if (o[k1] === undefined) return;
      var g = [o[k1]];
      if (o[k2] && o[k2] !== 'none') g.push(o[k2]);
      o[out] = g;
    }
    pair('h_goal1', 'h_goal2', 'h_goals');
    /* "no styling products" cancels a styling goal, unless it was the only one */
    if (o.h_hold === '0' && o.h_goals && o.h_goals.length > 1) o.h_goals = o.h_goals.filter(function (g) { return g !== 'hold'; });
    pair('f_concern1', 'f_concern2', 'f_concerns');
    pair('b_need1', 'b_need2', 'b_needs');
    return o;
  }

  /* ------------------------------------------- copy: botanical notes -- */

  var BLURBS = {
    'frequent-use-bath': 'Biodynamic lemon balm keeps a frequently washed scalp in balance.',
    'moisturizing-hair-bath-new-1': 'Biodynamic oat binds water into thirsty lengths.',
    'volumizing-hair-bath-copy': 'Biodynamic yarrow builds body at the root, without weight.',
    'curly-hair-bath': "Almond protein and organic St. John's wort keep curls springy while cleansing.",
    'curly-hair-co-wash': 'A one-step cleanse that conditions as it purifies, with biodynamic fennel.',
    'smooth-n-glow-hair-bath-240ml': 'Biodynamic Damask rose smooths the strand while it washes.',
    'color-protection-hair-bath-240-ml': 'Kakadu plum and goji berry shield colour from fading.',
    'bluemoon-hair-bath': 'Violet botanicals cool yellow tones; Spanish broom softens.',
    'fortifying-hair-bath': 'Horse chestnut and peppermint energise the roots.',
    'sebum-balance-hair-bath-240-ml': 'Biodynamic sage rebalances an oily scalp at the source.',
    'purifying-hair-bath-dry-scalps-new': 'Willow bark calms dry flaking; the scalp stays comfortable.',
    'purifying-hair-bath-oily-scalp': 'Biodynamic thyme and organic nettle purify and rebalance.',
    'soothing-hair-bath-240-ml': 'Helichrysum and fennel calm sensitive scalps. Gentle enough for every day.',
    'hair-body-invigorating-wash-240-ml': 'Juniper and maqui berry refresh hair and body in one step.',
    'frequent-use-hair-conditioner': 'Feather-light slip that detangles without weighing hair down.',
    'volumizing-hair-conditioner': 'Upcycled apple fiber thickens each strand and detangles without flattening the root.',
    'smooth-n-glow-hair-conditioner': 'Damask rose and upcycled apple seed oil seal lengths against damp air.',
    'enriching-hair-conditioner': 'Spanish broom and gentian soften blonde and grey lengths.',
    'moisturizing-hair-mask-new-1': 'Organic olive replenishes what very dry hair has lost.',
    'smooth-n-glow-hair-mask-160ml': 'Coconut oil works deep while rose smooths the surface. Light enough for fine hair.',
    'color-protection-hair-mask': 'Grape leaf polyphenols lock pigment in; linseed seals the cuticle.',
    'sunset-hour-hair-mask': 'Warms golden and caramel tones while rice bran oil conditions.',
    'bluemoon-hair-mask': 'Deep violet toning with rice bran softness.',
    'fortifying-hair-lotion': "Buddleja stem cells prolong the follicle's growth phase.",
    'revitalizing-hair-lotion': 'Gentle, alcohol-free follicle care with green coffee.',
    'hydro-balance-scalp-gel-new': 'Lysine and biodynamic sage keep sweat from flattening your day.',
    'purifying-hair-lotion-dry-scalp': 'Willow bark relief between washes, no rinsing needed.',
    'purifying-hair-lotion-oily-scalps': 'Thyme and burdock keep buildup from returning.',
    'soothing-remedy-50-ml': 'Organic aloe and biodynamic chamomile calm on contact.',
    'comforting-scalp-oil': 'Rice bran and calendula restore a dry scalp before washing.',
    'flowerfall-160-ml': 'Pure botanical waters of lavender, rosemary, and rose.',
    'everlasting-hair-booster': 'Castor, shea, and sacha inchi rebuild what processing took away.',
    'ph-hair-equalizer': 'A gentle vinegar rinse that closes the cuticle for shine and colour hold.',
    'rebuildm-hair-serum': 'Amino acids rebuild the fibre. No rinsing needed.',
    'sublime-hair-milk-100ml': 'Marula and coconut smooth and soften without weight.',
    'smoothing-cream-150-ml': 'Guar conditioners and marula smooth frizz, no silicones.',
    'thermo-detangling-cloud-240ml': 'A weightless veil that detangles and shields from hot tools.',
    'smooth-n-glow-serum-50ml': 'Upcycled apple seed oil seals the strand, so damp air finds nothing to lift.',
    'glossy-nectar160ml': 'Marula and apple seed oil for glass-like shine and heat protection.',
    'nurturing-drops50ml': 'California poppy and apple seed oil seal worn ends.',
    'color-protection-veil-160-ml': 'Kakadu plum antioxidants shield colour between washes.',
    'sunlight-serum': 'Rice bran oil absorbs UV; pomegranate rebuilds the barrier.',
    'finest-fluid': 'Moonstone luminosity, light enough for fine hair.',
    'curl-priming-cream-150ml': 'Bioferment moisture and marula slip. Curls defined, nothing on show.',
    'curly-potion240ml': 'California poppy and orange pulp protein for springy, lasting definition.',
    'next-day': 'Castor oil and squalane for that lived-in, second-day texture.',
    'sea-salt-spray-240ml': 'Sea salt texture, kept soft by marula.',
    'bodifying-hair-renewer160ml': 'Amino acids and marula lift fine hair from the root.',
    'flux-potion-240ml': 'Soft structure with marula shine, never stiff.',
    'glimmering-bond-100ml': 'Marula-conditioned hold with a glossy cast you scrunch out.',
    'quick-glue100ml': 'Strong satin-finish control, softened by castor and marula.',
    'molding-mist-240ml': 'Flexible mist hold that brushes out clean.',
    'boho-pomade-50ml': 'Olive esters for tousled, touchable definition.',
    'shaping-putty50ml': 'Sculpted semi-matte control with nourishing marula.',
    'precious-wax': 'Castor, shea, and carnauba for polished, undone texture.',
    'face-beard-hydrating-cleanser-150-ml': 'Maqui berry and tamarind cleanse without stripping.',
    'perfect-skin-cleansing-cream': 'A balm of passionflower and shea that melts makeup away.',
    'glowing-face-gommage': 'Kaolin and alpine willowherb refine and rebalance.',
    'resurfacing-face-peel': 'Tropical fruit enzymes resurface, gently.',
    'enlivening-face-mist': 'Biodynamic mullein and prickly pear, fragrance-free.',
    'rebalancing-face-concentrate': 'Biodynamic rosemary clears congestion; flax rebalances.',
    're-blooming-face-serum': 'Biodynamic licorice visibly fades dark spots.',
    're-lieving-face-serum': 'Chamomile and red poppy calm reactive skin, fragrance-free.',
    're-vitalizing-face-serum': 'Japanese cedar bud firms; grape resveratrol defends.',
    'pure-balance-face-cream': 'Savory and burdock keep shine in check all day.',
    'marvelous-skin-relief-face-cream': 'Chamomile and oat comfort skin that reacts to everything.',
    'blooming-gleam-face-cream': 'Fruit acids and mineral micro-pearls for a lit-from-within glow.',
    'age-better-face-mask': 'Hibiscus and baobab lift and firm.',
    'calming-face-mask': 'Balloon vine and mallow soothe stressed skin.',
    'miracle-eye-complex-20-ml': 'Pataua and avocado restore density to the eye contour.',
    'face-eye-energizing-texture-50-ml': 'Resurrection plant revives; zeolite keeps the finish matte.',
    'softening-shave-cream-100-ml': 'Bacuri butter cushions every pass of the blade.',
    'repairing-aftershave-balm-50-ml': 'Siberian ginseng and maqui calm freshly shaven skin.',
    'lip-beard-salve-30-ml': 'Shea and black cumin soften beard and lips.',
    'velvet-body-fluid-50-ml': 'Olive and passionflower melt in for lasting softness.',
    'fabulous-body-oil': 'Almond and helichrysum with a dry-touch satin finish.',
    'afterglow-body-renovater': 'Upcycled olive seed polishes, calendula soothes.',
    'extraordinary-body-amplifier-280': 'Pink pepper and caraway tone and firm.',
    'shaping-treatment': 'Blackcurrant and maca firm; mint cools.',
    'fabulous-foot-cream': 'Shea and date oil soften; peppermint relieves.',
    'nebula': 'Rice bran and biodynamic thyme for soft hands.',
    'terso': 'A micellar hand cleanse with thyme and bergamot.',
    'after-sun-body-balm-new': 'Calendula and pomegranate calm sun-stressed skin.',
    'volumizing-root-spray-160ml': 'Biodynamic California poppy and rice protein lift the root without weight.',
    'plant-mineral-refresh-36-gr': 'Rice and tapioca starch drink up oil at the root, with biodynamic lemon balm to keep the scalp comfortable.'
  };

  var REASONS = {
    humid_glycerin: 'Humid air makes some ingredients pull moisture the wrong way, so we picked formulas that seal the strand instead. Upcycled apple seed oil leaves damp air nothing to grab.',
    pref_glycerin: 'As you asked, every leave-in here is glycerin free. Botanical films do the protecting instead.',
    weight: 'Everything here is chosen light on purpose, so fine hair keeps its lift.',
    keratin: 'We chose the gentlest cleanse in the line, so your smoothing treatment lasts longer.',
    postpartum: 'A gentle, alcohol free pick. Our formulas are rich in botanical essential oils, so if you are pregnant or nursing, check your routine with your doctor first.',
    dry_climate: 'In dry air, moisture drawing botanicals are your friend. We leaned into them.'
  };

  /* ------------------------------------------------------- the engine -- */

  var CADENCE_LABEL = {
    'every-wash': 'Every wash', 'daily': 'Daily', 'weekly': 'Once a week',
    '1-2x-week': '1 to 2 times a week', 'as-needed': 'When needed', 'course': '2 to 3 times a week'
  };

  function Engine(data) { this.p = data.products; }

  Engine.prototype.run = function (a) {
    a = withGoals(a);
    if (a.area === 'hair') return this.hair(a);
    if (a.area === 'face') return this.face(a);
    if (a.area === 'body') return this.simpleMatch(a, ['body'], a.b_needs || [], 3);
    if (a.area === 'shave') return this.shave(a);
    return { steps: [], notes: [] };
  };

  Engine.prototype.get = function (h) { var d = this.p[h]; return d ? Object.assign({ handle: h }, d) : null; };

  Engine.prototype.byRole = function (role) {
    var out = [];
    for (var h in this.p) if ((this.p[h].roles || []).indexOf(role) !== -1) out.push(this.get(h));
    return out;
  };

  /* ---- hair ---- */
  Engine.prototype.hair = function (a) {
    var notes = [], self = this;
    var goals = (a.h_goals || []).slice();
    var prefs = a.h_prefs || [];
    var scalp = a.h_scalp || [];
    var lengths = a.h_lengths || [];
    var color = a.h_color || [];
    var humid = a.h_climate === 'humid';
    var dryAir = a.h_climate === 'dry';
    var porous = a.h_porous === 'yes';
    var keratin = color.indexOf('keratin') !== -1;
    var pregnancy = prefs.indexOf('pregnancy') !== -1;

    /* needs: the main goal is primary (3 pts), the second goal is goal2 (2 pts),
       everything read from the descriptive answers is secondary (2 pts) */
    var primary = {}, secondary = {}, goal2 = {};
    var g1 = goals[0], g2 = goals[1];
    function goalNeed(g) {
      if (g === 'tone') return color.indexOf('warm') !== -1 ? 'brass_warm_wanted' : 'brass_yellow';
      if (g === 'hairloss') return 'hair_loss';
      return g; /* scalp is resolved from the scalp answers below */
    }
    if (g1 && g1 !== 'scalp') primary[goalNeed(g1)] = 1;
    if (g2 && g2 !== 'scalp') goal2[goalNeed(g2)] = 1;
    if (lengths.indexOf('dry') !== -1) secondary.dryness = 1;
    if (lengths.indexOf('damaged') !== -1) secondary.damage = 1;
    if (lengths.indexOf('split_ends') !== -1) secondary.split_ends = 1;
    if (color.indexOf('colored') !== -1) secondary.color_fade = 1;
    if (color.indexOf('cool') !== -1) secondary.brass_yellow = 1;
    if (color.indexOf('warm') !== -1) secondary.brass_warm_wanted = 1;
    if (keratin) secondary.keratin_maintenance = 1;
    if (a.h_washfreq === 'daily') secondary.frequent_wash = 1;
    if (a.h_weighed === 'yes') secondary.weighed_down = 1;
    if (scalp.indexOf('oily') !== -1) secondary.oily_scalp = 1;
    if (scalp.indexOf('sweat') !== -1) secondary.sweat = 1;
    if (scalp.indexOf('sensitive') !== -1) secondary.sensitive_scalp = 1;
    if (scalp.indexOf('shedding') !== -1) secondary.hair_loss = 1;
    if (scalp.indexOf('flaky') !== -1) secondary[a.h_flake_type === 'greasy' ? 'oily_dandruff' : 'dry_flaky_scalp'] = 1;
    if (g1 === 'scalp' || g2 === 'scalp') {
      var dest = g1 === 'scalp' ? primary : goal2;
      for (var k in secondary) if (/scalp|dandruff|sweat|hair_loss/.test(k)) { dest[k] = 1; delete secondary[k]; }
    }
    secondary.detangle = secondary.detangle || 0.5;
    var anyNeed = function (k) { return !!(primary[k] || goal2[k] || secondary[k]); };

    var tol = a.h_strand === 'thick' ? 3 : a.h_strand === 'fine' ? 1 : 2;
    if (a.h_weighed === 'yes') tol = Math.max(0, tol - 1);
    var holdWanted = a.h_hold ? parseInt(a.h_hold, 10) : 0;
    var finishWanted = a.h_finish === 'invisible' ? 'natural' : a.h_finish;
    var needInvisible = a.h_finish === 'invisible';

    /* hard filters */
    var noGlycerin = prefs.indexOf('no_glycerin') !== -1 || humid;
    var leaveOnRoles = { leavein: 1, styler: 1, finisher: 1, scalp_leavein: 1, booster: 0 };
    function allowed(p) {
      var leaveOn = (p.roles || []).some(function (r) { return leaveOnRoles[r]; });
      if (noGlycerin && leaveOn && p.glycerin_leavein && (p.humectant || 0) >= (humid && prefs.indexOf('no_glycerin') === -1 ? 2 : 0)) return false;
      if (prefs.indexOf('no_silicone') !== -1 && p.silicone) return false;
      if (prefs.indexOf('fragrance_free') !== -1 && leaveOn && !p.fragrance_free) return false;
      if (needInvisible && (p.roles.indexOf('styler') !== -1 || p.roles.indexOf('finisher') !== -1) && !p.invisible) return false;
      if (p.pigment === 'violet' && !anyNeed('brass_yellow')) return false;
      if (p.pigment === 'warm' && !anyNeed('brass_warm_wanted')) return false;
      if (p.line === 'purifying-oily' && !anyNeed('oily_dandruff')) return false;
      if (p.line === 'purifying-dry' && !anyNeed('dry_flaky_scalp')) return false;
      if (keratin) {
        if (p.pigment && p.pigment !== 'none') return false;
        if (/purifying|sebum/.test(p.line || '')) return false;
        if (p.roles.indexOf('cleanse') !== -1 && !p.keratin_safe && !p.subKeratin) return false;
      }
      var types = p.types || ['all'];
      if (types.indexOf('all') === -1 && types.indexOf(a.h_pattern) === -1) return false;
      return true;
    }

    var SCALP_NEEDS = { hair_loss: 1, oily_scalp: 1, dry_flaky_scalp: 1, oily_dandruff: 1, sensitive_scalp: 1, sweat: 1 };
    var goalKeys = Object.keys(primary).concat(Object.keys(goal2));
    var scalpOnly = goalKeys.length > 0 && goalKeys.every(function (k) { return SCALP_NEEDS[k]; });
    var RINSE_OFF = { cleanse: 1, cowash: 1, condition: 1, mask: 1, toner_mask: 1, scalp_rinse: 1 };
    function hits(p, set) { return (p.concerns || []).some(function (c) { return set[c]; }); }
    function score(p, slotRole) {
      var s = 0;
      (p.concerns || []).forEach(function (c) {
        if (primary[c]) s += 3;
        else if (goal2[c]) s += 2;
        else if (secondary[c]) s += 2 * (secondary[c] === 0.5 ? 0.25 : 1);
      });
      /* one product that serves both goals beats two that serve one each */
      if (g2 && hits(p, primary) && hits(p, goal2)) s += 1;
      if ((p.types || []).indexOf(a.h_pattern) !== -1) s += 1;
      /* weigh-down penalty: full strength on leave-ons, softened for rinse-off */
      var rinse = RINSE_OFF[slotRole];
      s -= (rinse ? 1 : 2) * Math.max(0, (p.weight || 0) - (rinse ? tol + 1 : tol));
      if (slotRole === 'styler' || slotRole === 'finisher') {
        if (holdWanted) s -= 2 * Math.abs((p.hold || 0) - holdWanted);
        if (finishWanted && p.finish === finishWanted) s += 1;
      }
      if (humid && p.film_former) s += 1;
      if (dryAir && (p.humectant || 0) >= 2) s += 1;
      if (p.line === 'fortifying') { if (primary.hair_loss) s += 2; else if (goal2.hair_loss) s += 1; }
      /* a toner is the definitive answer when tone correction is asked for */
      if (p.pigment && p.pigment !== 'none') s += 1;
      /* a routine still needs a conditioner even when the goal is all about the scalp */
      if (scalpOnly && slotRole === 'condition') s += 2;
      var gentleScalp = pregnancy || a.h_shed_scalp === 'sensitive';
      if (gentleScalp && p.handle === 'revitalizing-hair-lotion') s += 2;
      if (gentleScalp && p.handle === 'fortifying-hair-lotion') s -= 3;
      return s;
    }

    function ranked(role) {
      return self.byRole(role).filter(allowed)
        .map(function (p) { return { p: p, s: score(p, role) }; })
        .sort(function (x, y) { return y.s - x.s; });
    }

    /* slot activation */
    var need = function () { for (var i = 0; i < arguments.length; i++) if (anyNeed(arguments[i])) return true; return false; };
    var slots = [];
    if (need('sweat')) slots.push({ id: 'scalp_pre', role: 'scalp_rinse', order: 0, label: 'Before washing' });
    slots.push({ id: 'cleanse', role: 'cleanse', order: 1, label: 'Cleanse', required: true });
    slots.push({ id: 'condition', role: 'condition', order: 3, label: 'Condition', required: !scalpOnly });
    if (need('dryness', 'damage', 'curl_definition') || porous || goals.indexOf('frizz') !== -1) slots.push({ id: 'mask', role: 'mask', order: 4, label: 'Weekly treatment' });
    if (need('brass_warm_wanted') && !keratin) slots.push({ id: 'toner_mask', role: 'toner_mask', order: 5, label: 'Weekly toning' });
    if (need('hair_loss', 'dry_flaky_scalp', 'oily_dandruff', 'sensitive_scalp')) slots.push({ id: 'scalp_leavein', role: 'scalp_leavein', order: 6, label: 'Scalp treatment' });
    if (need('frizz', 'heat_protect', 'color_fade', 'split_ends', 'shine', 'dryness', 'hair_loss') || keratin) slots.push({ id: 'leavein', role: 'leavein', order: 7, label: 'Leave-in' });
    /* a styler only when styling is actually wanted: never when the customer opted out */
    if (a.h_hold !== '0' && need('hold', 'curl_definition', 'texture')) slots.push({ id: 'styler', role: 'styler', order: 8, label: 'Style' });

    /* fill */
    var picked = [], usedHandles = {}, usedLines = {};
    var protein2Used = 0, proteinCapOn = !need('damage');
    function conflicts(p) {
      if ((p.conflicts || []).some(function (h) { return usedHandles[h]; })) return true;
      for (var i = 0; i < picked.length; i++) {
        var q = picked[i].p;
        if ((q.conflicts || []).indexOf(p.handle) !== -1) return true;
        if (p.pigment && p.pigment !== 'none' && q.pigment && q.pigment !== 'none' && q.pigment !== p.pigment) return true;
      }
      if (proteinCapOn && (p.protein || 0) === 2 && protein2Used) return true;
      return false;
    }
    slots.forEach(function (slot) {
      var list = ranked(slot.role).filter(function (r) { return !usedHandles[r.p.handle] && !conflicts(r.p); });
      var best = list[0];
      if (!best || (best.s < 2 && !slot.required)) return;
      if (slot.required && (!best || best.s < 2)) {
        /* sensible default cleanse/conditioner */
        var fallback = slot.role === 'cleanse'
          ? (a.h_pattern === 'curly' || a.h_pattern === 'coily' ? 'curly-hair-bath' : 'frequent-use-bath')
          : (a.h_pattern === 'curly' || a.h_pattern === 'coily' ? 'curly-hair-co-wash' : 'frequent-use-hair-conditioner');
        var fb = self.get(fallback);
        if (fb && allowed(fb) && !usedHandles[fallback]) best = { p: fb, s: 2, ranked: list };
        if (!best) return;
      }
      /* curl definition + strong hold: keep a true definer as the wet-stage styler,
         the extra hold comes from a layered finisher (rule: layering, spec §5.4) */
      if (slot.role === 'styler' && primary.curl_definition && holdWanted >= 3) {
        var definer = list.find(function (r) { return (r.p.concerns || []).indexOf('curl_definition') !== -1 && (r.p.hold || 0) <= 2; });
        if (definer) best = definer;
      }
      /* line coherence nudge: prefer same line if within 1 point */
      var mate = list.find(function (r) { return r.p.line && usedLines[r.p.line] && best.s - r.s <= 1; });
      if (mate) best = mate;
      picked.push({ slot: slot, p: best.p, s: best.s, ranked: list,
        hit: (best.p.concerns || []).some(function (c) { return primary[c]; }) });
      usedHandles[best.p.handle] = 1;
      if (best.p.line) usedLines[best.p.line] = 1;
      if ((best.p.protein || 0) === 2) protein2Used = 1;
    });

    /* keratin overrides */
    if (keratin) {
      var cl = picked.find(function (x) { return x.slot.id === 'cleanse'; });
      if (cl && !cl.p.keratin_safe) { var sb = this.get('soothing-hair-bath-240-ml'); if (sb) { usedHandles[cl.p.handle] = 0; cl.p = sb; cl.note = REASONS.keratin; usedHandles[sb.handle] = 1; } }
      if (!usedHandles['ph-hair-equalizer']) {
        picked.push({ slot: { id: 'leavein2', role: 'leavein', order: 7.5, label: 'Seal' }, p: this.get('ph-hair-equalizer'), s: 4, hit: true });
        usedHandles['ph-hair-equalizer'] = 1;
      }
    }

    /* wash-frequency planning: a cleanse that cannot carry every wash gets a
       companion for the days in between, with explicit alternation wording */
    var USER_FREQ = { daily: 7, often: 3, weekly: 1.5 }[a.h_washfreq] || 3;
    function maxWashFreq(p) {
      var c = p.cadence || 'every-wash';
      if (c === 'course') return 3;
      if (c === '1-2x-week') return 2;
      if (c === 'weekly') return 1;
      return 99;
    }
    function freqPhrase(mf) {
      return mf >= 3 ? '2 to 3 washes a week' : mf === 2 ? '1 to 2 washes a week' : 'One wash a week';
    }
    var cleansePick = picked.find(function (x) { return x.slot.id === 'cleanse'; });
    if (cleansePick && maxWashFreq(cleansePick.p) < USER_FREQ) {
      var mf = maxWashFreq(cleansePick.p);
      var daily = ranked('cleanse').find(function (r) {
        return !usedHandles[r.p.handle] && maxWashFreq(r.p) >= USER_FREQ && !conflicts(r.p);
      });
      if (daily) {
        cleansePick.rotation = true;
        cleansePick.slot = { id: 'rotation', role: 'cleanse', order: 2, label: 'Alternating', required: true };
        cleansePick.cadenceLabel = freqPhrase(mf) + ', alternating with {{daily}}';
        picked.push({ slot: { id: 'cleanse', role: 'cleanse', order: 1, label: 'Cleanse', required: true }, p: daily.p, s: daily.s, companion: true, cadenceLabel: 'The washes in between' });
        usedHandles[daily.p.handle] = 1;
      } else {
        cleansePick.cadenceLabel = freqPhrase(mf);
      }
    } else if (cleansePick && cleansePick.p.cadence === 'course') {
      /* the treatment cleanse fits this wash rhythm, so it simply becomes the wash */
      cleansePick.cadenceLabel = 'Every wash';
    }

    /* violet toning need with no toner picked → offer bluemoon as rotation */
    if (need('brass_yellow') && !picked.some(function (x) { return (x.p.pigment || 'none') !== 'none'; }) && !keratin) {
      var bm = this.get('bluemoon-hair-bath');
      if (bm && !usedHandles[bm.handle]) { picked.push({ slot: { id: 'rotation', role: 'cleanse', order: 2, label: 'Weekly toning', required: true }, p: bm, s: 5, rotation: true, hit: true, cadenceLabel: '1 to 2 washes a week, alternating with {{daily}}' }); usedHandles[bm.handle] = 1; }
    }

    /* hold layering */
    var styler = picked.find(function (x) { return x.slot.id === 'styler'; });
    if (styler && holdWanted >= 3 && (styler.p.hold || 0) < holdWanted) {
      var fin = ranked('finisher').find(function (r) { return !usedHandles[r.p.handle] && (r.p.hold || 0) >= 3 && !conflicts(r.p); });
      if (fin) {
        picked.push({ slot: { id: 'finisher', role: 'finisher', order: 9, label: 'Lock in' }, p: fin.p, s: fin.s, layerOver: styler.p.handle });
        usedHandles[fin.p.handle] = 1;
      }
    }

    /* cap the ritual at 4 products (start-here plus up to 3), then tier.
       A styler and the finisher layered over it count as one unit, so an
       explicit hold request is never split in half by the cap. */
    if (picked.length > 4) {
      var keep4 = picked.filter(function (x) { return x.slot.required; });
      var units = [];
      picked.filter(function (x) { return !x.slot.required && !x.layerOver; }).forEach(function (x) {
        var layered = picked.filter(function (y) { return y.layerOver === x.p.handle; });
        units.push({ items: [x].concat(layered), hit: x.hit || layered.some(function (y) { return y.hit; }), s: Math.max.apply(null, [x.s].concat(layered.map(function (y) { return y.s; }))) });
      });
      /* units answering the main goal survive the cut before second-goal ones */
      units.sort(function (x, y) { return ((y.hit ? 1 : 0) - (x.hit ? 1 : 0)) || (y.s - x.s); });
      var room = Math.max(0, 4 - keep4.length);
      picked = keep4.slice();
      units.forEach(function (u) { if (room > 0) { picked = picked.concat(u.items); room -= 1; } });
    }
    picked.sort(function (x, y) { return x.slot.order - y.slot.order; });
    assignTiers(picked);

    /* notes */
    if (humid && goals.indexOf('frizz') !== -1) notes.push(REASONS.humid_glycerin);
    else if (prefs.indexOf('no_glycerin') !== -1) notes.push(REASONS.pref_glycerin);
    if (dryAir) notes.push(REASONS.dry_climate);
    if (tol <= 1) notes.push(REASONS.weight);
    if (pregnancy) notes.push(REASONS.postpartum);

    return { steps: picked, notes: notes };
  };

  /* ---- face ---- */
  Engine.prototype.face = function (a) {
    var concerns = (a.f_concerns || []).slice();
    var skinMap = { dry: 'skin_dry', oily: 'skin_oily', combo: 'skin_combo', sensitive: 'skin_sensitive' };
    if (skinMap[a.f_skin]) concerns.push(skinMap[a.f_skin]);
    var ff = a.f_ff === 'yes' || a.f_skin === 'sensitive';
    var self = this;
    function pick(role, extra) {
      var list = self.byRole(role).filter(function (p) { return p.line !== 'men' && !(ff && role !== 'face_cleanse' && !p.fragrance_free && a.f_ff === 'yes'); })
        .map(function (p) {
          var s = 0;
          (p.concerns || []).forEach(function (c) { var i = concerns.indexOf(c); if (i === 0) s += 3; else if (i !== -1) s += 2; });
          if (extra && extra[p.handle]) s += extra[p.handle];
          return { p: p, s: s };
        }).sort(function (x, y) { return y.s - x.s; });
      return list[0] && list[0].s > 0 ? list[0] : null;
    }
    var picked = [];
    var serum = pick('face_serum');
    var cream = pick('face_cream', serum ? objFromPairs(serum.p.pairs, 2) : null);
    var cleanse = pick('face_cleanse');
    if (cleanse) picked.push({ slot: { id: 'f1', order: 1, label: 'Cleanse' }, p: cleanse.p, s: cleanse.s });
    if (serum) picked.push({ slot: { id: 'f2', order: 2, label: 'Treat' }, p: serum.p, s: serum.s + 1 });
    if (cream) picked.push({ slot: { id: 'f3', order: 3, label: 'Moisturise' }, p: cream.p, s: cream.s });
    if (concerns.indexOf('eye_area') !== -1) { var eye = pick('face_eye'); if (eye) picked.push({ slot: { id: 'f4', order: 4, label: 'Eye contour' }, p: eye.p, s: eye.s + 1 }); }
    var mask = pick('face_mask'); if (mask) picked.push({ slot: { id: 'f5', order: 5, label: 'Weekly treatment' }, p: mask.p, s: mask.s });
    var mist = pick('face_mist'); if (mist) picked.push({ slot: { id: 'f6', order: 6, label: 'Refresh' }, p: mist.p, s: mist.s - 1 });
    return this.applyDepth(a, picked, ['f2']);
  };

  function objFromPairs(arr, val) { var o = {}; (arr || []).forEach(function (h) { o[h] = val; }); return o; }

  /* ---- body / simple ---- */
  Engine.prototype.simpleMatch = function (a, roles, wants, capOrder) {
    var self = this, picked = [];
    var list = [];
    roles.forEach(function (r) { list = list.concat(self.byRole(r)); });
    /* at most two products per need, so the second need is never crowded out */
    var perNeed = {};
    list.map(function (p) {
      var s = 0, best = -1;
      (p.concerns || []).forEach(function (c) { var i = wants.indexOf(c); if (i === -1) return; s += i === 0 ? 3 : 2; if (best === -1 || i < best) best = i; });
      return { p: p, s: s, need: best };
    }).filter(function (x) { return x.s > 0; })
      .sort(function (x, y) { return y.s - x.s; })
      .forEach(function (x) {
        if ((perNeed[x.need] || 0) >= 2 || picked.length >= 4) return;
        perNeed[x.need] = (perNeed[x.need] || 0) + 1;
        picked.push({ slot: { id: 'b' + picked.length, order: picked.length + 1, label: x.p.cadence === '1-2x-week' ? 'Weekly' : 'Daily' }, p: x.p, s: x.s, hit: x.need === 0 });
      });
    return this.applyDepth(a, picked, []);
  };

  /* ---- shave ---- */
  Engine.prototype.shave = function (a) {
    var picked = [
      { slot: { id: 's1', order: 1, label: 'Prepare' }, p: this.get('face-beard-hydrating-cleanser-150-ml'), s: 3 },
      { slot: { id: 's2', order: 2, label: 'Shave' }, p: this.get('softening-shave-cream-100-ml'), s: 5 },
      { slot: { id: 's3', order: 3, label: 'Repair' }, p: this.get('repairing-aftershave-balm-50-ml'), s: 4 }
    ];
    if (a.s_beard === 'yes') picked.push({ slot: { id: 's4', order: 4, label: 'Beard care' }, p: this.get('lip-beard-salve-30-ml'), s: 3 });
    return this.applyDepth(a, picked.filter(function (x) { return x.p; }), ['s2']);
  };

  /* two tiers: 'hero' = the single best answer, 'base' = everything else (max 3) */
  var HERO_RANK = { cleanse: 0, scalp_leavein: 1, leavein: 2, mask: 3, styler: 4, condition: 5, scalp_rinse: 6, toner_mask: 3, finisher: 9,
                    f2: 0, f3: 1, f1: 2, f4: 3, f5: 4, f6: 5, s2: 0, s3: 1, s1: 2, s4: 3 };
  function heroRank(x) {
    var r = HERO_RANK[x.slot.role]; if (r === undefined) r = HERO_RANK[x.slot.id];
    return r === undefined ? 2 : r;
  }
  function assignTiers(picked) {
    if (!picked.length) return;
    /* the hero must stand alone (no layered finishers) and answer a primary goal;
       on close scores the core step (the wash, the treatment) wins over a companion */
    var standalone = picked.filter(function (x) { return !x.layerOver; });
    var pool = standalone.filter(function (x) { return x.hit; });
    if (!pool.length) pool = standalone.length ? standalone : picked;
    var hero = pool.slice().sort(function (x, y) { return (y.s - 0.6 * heroRank(y)) - (x.s - 0.6 * heroRank(x)); })[0];
    picked.forEach(function (x) { x.tier = x === hero ? 'hero' : 'base'; });
  }

  Engine.prototype.applyDepth = function (a, picked, mustKeepIds) {
    picked.forEach(function (x) { if (x.hit === undefined) x.hit = true; });
    if (picked.length > 4) {
      var keep = picked.filter(function (x) { return mustKeepIds.indexOf(x.slot.id) !== -1; });
      var rest = picked.filter(function (x) { return mustKeepIds.indexOf(x.slot.id) === -1; }).sort(function (x, y) { return y.s - x.s; });
      picked = keep.concat(rest.slice(0, 4 - keep.length));
    }
    picked.sort(function (x, y) { return x.slot.order - y.slot.order; });
    assignTiers(picked);
    return { steps: picked, notes: [] };
  };

  /* ------------------------------------- availability + presentation -- */

  var liveCache = {};
  function fetchLive(handle) {
    if (liveCache[handle]) return liveCache[handle];
    liveCache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (j) {
        var v = (j.variants || []).find(function (v) { return v.available; });
        return { ok: true, available: !!v, variantId: v && v.id, price: j.price, title: j.title,
                 url: j.url, image: (j.featured_image || (j.images && j.images[0]) || '') };
      })
      .catch(function () { return { ok: false, available: false }; });
    return liveCache[handle];
  }

  function resolveAvailability(result, engine) {
    /* walk each step: winner → explicit subs → next ranked; drop if nothing available.
       `used` prevents a substitution from duplicating another step's product. */
    var used = {};
    result.steps.forEach(function (s) { used[s.p.handle] = 1; });
    var chain = Promise.resolve();
    result.steps.forEach(function (step) {
      chain = chain.then(function () {
        var walk = [step.p.handle].concat(step.p.subs || []);
        (step.ranked || []).forEach(function (r) { if (walk.indexOf(r.p.handle) === -1) walk.push(r.p.handle); });
        var i = 0;
        function tryNext() {
          if (i >= walk.length) { step.dead = true; delete used[step.p.handle]; return Promise.resolve(); }
          var h = walk[i++];
          if (h !== step.p.handle && used[h]) return tryNext();
          var attrs = engine.get(h);
          if (!attrs) return tryNext();
          return fetchLive(h).then(function (live) {
            if (h === step.p.handle && !live.available && live.title) step.originalTitle = live.title;
            if (!live.available) return tryNext();
            if (h !== step.p.handle) {
              step.substitutedFrom = step.p.handle;
              delete used[step.p.handle];
              step.p = attrs;
              used[h] = 1;
            }
            step.live = live;
            return null;
          });
        }
        return tryNext();
      });
    });
    return chain.then(function () {
      result.steps = result.steps.filter(function (s) { return !s.dead; });
      return result;
    });
  }

  /* --------------------------------------------------------------- UI -- */

  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  function QuizUI(root, data) {
    this.root = root;
    this.engine = new Engine(data);
    this.ctaTop = document.querySelector('.rq-cta-top');
    this.ctaHome = this.ctaTop ? this.ctaTop.parentNode : null;
    this.ctaAnchor = document.querySelector('.rq-quiz-col');
    this.answers = {};
    this.trail = [];
    this.maxPct = 0;
    /* a persistent live region so screen readers hear each new question and the result */
    this.live = document.createElement('div');
    this.live.className = 'rq-sr';
    this.live.setAttribute('aria-live', 'polite');
    root.parentNode.insertBefore(this.live, root);
    this.render();
  }

  /* how long the flow is, so the counter and the bar never move backwards
     as branch questions appear (area question included) */
  var FLOW_LENGTH = { hair: 12, face: 4, body: 3, shave: 2 };

  QuizUI.prototype.scrollTop = function () {
    var header = document.querySelector('header');
    var off = (header ? header.getBoundingClientRect().height : 90) + 16;
    var y = this.root.getBoundingClientRect().top + window.pageYOffset - off;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  };

  QuizUI.prototype.visibleQuestions = function () {
    var a = withGoals(this.answers);
    function matches(cond) {
      return Object.keys(cond).every(function (key) {
        var want = cond[key], have = a[key];
        if (have === undefined) return false;
        var wants = Array.isArray(want) ? want : [want];
        var haves = Array.isArray(have) ? have : [have];
        return wants.some(function (w) { return haves.indexOf(w) !== -1; });
      });
    }
    return QUESTIONS.filter(function (q) {
      if (q.showIf && !matches(q.showIf)) return false;
      if (q.showAny && !q.showAny.some(matches)) return false;
      return true;
    });
  };

  QuizUI.prototype.currentIndex = function () {
    var qs = this.visibleQuestions();
    for (var i = 0; i < qs.length; i++) if (this.answers[qs[i].id] === undefined) return i;
    return -1;
  };

  QuizUI.prototype.render = function () {
    if (this.ctaTop && this.ctaHome && this.root.contains(this.ctaTop)) {
      this.ctaTop.classList.remove('rq-cta-compact');
      this.ctaHome.insertBefore(this.ctaTop, this.ctaAnchor);
    }
    var wrap = this.root.closest('.rq-wrap');
    if (wrap) wrap.classList.toggle('rq-started', this.trail.length > 0);
    var sticky = document.querySelector('.rq-sticky');
    if (sticky) sticky.remove();
    var qs = this.visibleQuestions();
    var idx = this.currentIndex();
    if (idx === -1) return this.renderResults();
    var q = qs[idx];
    var el = this.root, self = this;

    /* progress: answered / expected length, clamped so it only ever grows */
    var total = Math.max(qs.length, FLOW_LENGTH[this.answers.area] || 1);
    var n = this.trail.length + 1;
    var pct = Math.round((this.trail.length / total) * 100);
    if (pct < this.maxPct) pct = this.maxPct;
    this.maxPct = pct;
    var html = '<div class="rq-progress" role="progressbar" aria-valuemin="0" aria-valuemax="' + total + '" aria-valuenow="' + n + '"><span style="transform:scaleX(' + (pct / 100) + ')"></span></div>';
    html += '<div class="rq-step" role="group" aria-labelledby="rq-q">';
    html += '<h2 id="rq-q" class="rq-title">' + q.title + '</h2>';
    if (q.sub) html += '<p class="rq-sub">' + q.sub + '</p>';
    if (q.skip) html += '<button type="button" class="rq-skip" data-v="' + q.skip.v + '">' + q.skip.l + ' \u2192</button>';
    html += '<div class="rq-options">';
    /* the second-goal list never repeats the main goal */
    var opts = q.excludeAnswer ? q.options.filter(function (o) { return o.v !== self.answers[q.excludeAnswer]; }) : q.options;
    opts.forEach(function (o) {
      html += '<button type="button" class="rq-opt" data-v="' + o.v + '"' + (q.type === 'multi' ? ' aria-pressed="false"' : '') + '><span class="rq-opt-l">' + o.l + '</span>'
        + (o.d ? '<span class="rq-opt-d">' + o.d + '</span>' : '') + '</button>';
    });
    html += '</div>';
    if (q.type === 'multi') html += '<button type="button" class="rq-next" disabled>Continue</button>';
    html += '<div class="rq-nav">' + (this.trail.length ? '<button type="button" class="rq-back">Back</button>' : '') + '</div></div>';
    el.innerHTML = html;
    this.live.textContent = q.title;

    var skip = el.querySelector('.rq-skip');
    if (skip) skip.addEventListener('click', function () {
      var v = skip.getAttribute('data-v');
      self.answers[q.id] = q.type === 'multi' ? [v] : v; self.trail.push(q.id); self.render(); self.scrollTop();
    });
    var selected = [];
    el.querySelectorAll('.rq-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-v');
        if (q.type === 'single') {
          self.answers[q.id] = v; self.trail.push(q.id); self.render(); self.scrollTop();
        } else {
          var opt = q.options.find(function (o) { return o.v === v; });
          if (opt.solo) { selected = selected.indexOf(v) !== -1 ? [] : [v]; }
          else {
            var soloSel = q.options.filter(function (o) { return o.solo; }).map(function (o) { return o.v; });
            selected = selected.filter(function (s) { return soloSel.indexOf(s) === -1; });
            var i = selected.indexOf(v);
            if (i !== -1) selected.splice(i, 1);
            else { if (q.max && selected.length >= q.max) selected.shift(); selected.push(v); }
          }
          el.querySelectorAll('.rq-opt').forEach(function (b) {
            var on = selected.indexOf(b.getAttribute('data-v')) !== -1;
            b.classList.toggle('is-sel', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          el.querySelector('.rq-next').disabled = selected.length === 0;
        }
      });
    });
    var next = el.querySelector('.rq-next');
    if (next) next.addEventListener('click', function () {
      self.answers[q.id] = selected.slice(); self.trail.push(q.id); self.render(); self.scrollTop();
    });
    var back = el.querySelector('.rq-back');
    if (back) back.addEventListener('click', function () {
      var last = self.trail.pop();
      if (last) delete self.answers[last];
      /* also clear answers of questions that are no longer visible */
      var vis = self.visibleQuestions().map(function (x) { return x.id; });
      Object.keys(self.answers).forEach(function (k) { if (vis.indexOf(k) === -1) delete self.answers[k]; });
      self.maxPct = 0; /* going back is the one time the bar may retreat */
      self.render();
    });
  };

  /* headline personalised from the answers, goal first */
  var GOAL_TITLES = {
    frizz: 'For smooth, weightless calm',
    hairloss: 'For stronger, fuller hair',
    curl_definition: 'For curls that keep their shape',
    volume: 'For lift that lasts',
    dryness: 'For deeply quenched lengths',
    damage: 'For repaired, resilient hair',
    color_fade: 'For colour that stays vivid',
    hold: 'For a style that stays put',
    shine: 'For light, glossy shine'
  };
  var FACE_TITLES = {
    aging: 'For firmer, smoother skin',
    dark_spots: 'For an even, luminous tone',
    redness: 'For calm, comfortable skin',
    breakouts: 'For clear, balanced skin',
    dullness: 'For skin that glows again',
    eye_area: 'For brighter, rested eyes'
  };
  /* the second goal becomes a tail on the headline, never the lead */
  var GOAL_TAILS = {
    frizz: ', smooth and frizz-free', hairloss: ', with stronger roots', curl_definition: ', with curls that keep their shape',
    volume: ', with lift at the roots', dryness: ', deeply hydrated', damage: ', repaired along the way',
    color_fade: ', with colour that stays', hold: ', with a style that stays put', shine: ', with a glossy finish',
    scalp: ', with a comfortable scalp'
  };
  var FACE_TAILS = {
    aging: ', and firmer too', dark_spots: ', with a more even tone', redness: ', calm and comfortable',
    breakouts: ', clear and balanced', dullness: ', with more glow', eye_area: ', and rested eyes'
  };
  function ritualTitle(a) {
    a = withGoals(a);
    if (a.area === 'hair') {
      var g = (a.h_goals || [])[0], g2 = (a.h_goals || [])[1];
      var warm = (a.h_color || []).indexOf('warm') !== -1;
      var base;
      if (g === 'tone') base = warm ? 'For warmer, golden reflections' : 'For cooler, brighter reflections';
      else if (g === 'scalp') {
        var sc = a.h_scalp || [];
        if (sc.indexOf('shedding') !== -1) base = GOAL_TITLES.hairloss;
        else if (a.h_flake_type) base = 'For a calm, flake-free scalp';
        else if (sc.indexOf('sensitive') !== -1) base = 'For a soothed, comfortable scalp';
        else if (sc.indexOf('sweat') !== -1) base = 'For freshness through every workout';
        else if (sc.indexOf('oily') !== -1) base = 'For a fresh, balanced scalp';
        else base = 'For a happy, balanced scalp';
      }
      else base = GOAL_TITLES[g] || 'For your hair';
      var tail = g2 === 'tone' ? (warm ? ', with warmer reflections' : ', with cooler reflections') : (GOAL_TAILS[g2] || '');
      return base + tail;
    }
    if (a.area === 'face') {
      var f = (a.f_concerns || [])[0], f2 = (a.f_concerns || [])[1];
      if (FACE_TITLES[f]) return FACE_TITLES[f] + (FACE_TAILS[f2] || '');
      return a.f_skin === 'sensitive' ? 'For calm, comfortable skin' : 'For your skin';
    }
    if (a.area === 'body') return 'For skin that feels cared for';
    return 'For a smooth, calm shave';
  }
  function ritualSummary(a) {
    a = withGoals(a);
    var c = [];
    if (a.area === 'hair') {
      var P = { straight: 'Straight', wavy: 'Wavy', curly: 'Curly', coily: 'Coily' };
      var S = { fine: 'fine', medium: 'medium', thick: 'thick' };
      if (a.h_pattern) c.push(P[a.h_pattern] + (a.h_strand ? ', ' + S[a.h_strand] : '') + ' hair');
      var GL = { frizz: 'Anti-frizz', hairloss: 'Anti hair loss', curl_definition: 'Curl definition', volume: 'Volume', dryness: 'Hydration', damage: 'Repair', color_fade: 'Colour care', tone: 'Tone correction', hold: 'Styling', shine: 'Shine', scalp: 'Scalp comfort' };
      var g2 = (a.h_goals || [])[1];
      if (g2 && GL[g2]) c.push(GL[g2]);
      if (a.h_climate === 'humid') c.push('Humid air');
      if (a.h_climate === 'dry') c.push('Dry air');
      (a.h_color || []).forEach(function (v) {
        if (v === 'colored') c.push('Colour-treated');
        if (v === 'keratin') c.push('Keratin-treated');
      });
      if (a.h_shed_scalp === 'sensitive' || (a.h_scalp || []).indexOf('sensitive') !== -1) c.push('Sensitive scalp');
      if (a.h_washfreq === 'daily') c.push('Washes daily');
      if (a.h_washfreq === 'weekly') c.push('Washes weekly');
      (a.h_prefs || []).forEach(function (v) {
        if (v === 'fragrance_free') c.push('Fragrance-free');
        if (v === 'no_glycerin') c.push('Glycerin-free');
        if (v === 'no_silicone') c.push('Silicone-free');
        if (v === 'pregnancy') c.push('Extra gentle');
      });
    } else if (a.area === 'face') {
      var SK = { dry: 'Dry skin', oily: 'Oily skin', combo: 'Combination skin', sensitive: 'Sensitive skin', balanced: 'Balanced skin' };
      if (SK[a.f_skin]) c.push(SK[a.f_skin]);
      var f2 = (a.f_concerns || [])[1];
      var FL = { aging: 'Firmness', dark_spots: 'Even tone', redness: 'Calming', breakouts: 'Clarifying', dullness: 'Glow', eye_area: 'Eye care' };
      if (f2 && FL[f2]) c.push(FL[f2]);
      if (a.f_ff === 'yes') c.push('Fragrance-free');
    } else if (a.area === 'shave' && a.s_beard === 'yes') c.push('Beard');
    return c.slice(0, 4);
  }

  /* "Why we chose it": what the hero product does for the goals, in benefit terms,
     plus the one or two constraints from the answers that shaped the choice. */
  var GOAL_DOES = {
    frizz: 'smooths the strand so frizz has nothing to grab',
    hairloss: 'wakes up the roots so hair grows in stronger and fuller',
    curl_definition: 'shapes your curls and keeps them springy',
    volume: 'lifts from the root without adding weight',
    dryness: 'puts water back into thirsty lengths',
    damage: 'rebuilds the fibre after colour, bleach or heat',
    color_fade: 'keeps your colour vivid for longer',
    hold: 'holds the style exactly where you put it',
    shine: 'leaves a light, glossy finish',
    tone_cool: 'cools yellow and brassy tones',
    tone_warm: 'warms up the reflections',
    scalp_oily: 'rebalances an oily scalp',
    scalp_flaky: 'clears flakes and calms the scalp',
    scalp_sensitive: 'soothes an itchy, sensitive scalp',
    scalp_sweat: 'keeps the scalp fresh after training',
    scalp_balanced: 'keeps the scalp comfortable and balanced'
  };
  var FACE_DOES = {
    aging: 'firms the skin and softens fine lines', dark_spots: 'evens out the tone', redness: 'calms redness and comforts the skin',
    breakouts: 'clears congestion and keeps breakouts down', dullness: 'brings back the glow', eye_area: 'brightens and de-puffs the eye area'
  };
  var BODY_DOES = {
    body_hydration: 'keeps the skin soft and deeply hydrated', body_glow: 'leaves a silky, glowing finish', body_exfoliation: 'polishes the skin smooth',
    body_firming: 'tones and firms', hands: 'repairs busy, dry hands', feet: 'softens and relieves tired feet', sun_protection: 'calms sun-stressed skin'
  };
  function goalKey(a, g) {
    if (g === 'tone') return (a.h_color || []).indexOf('warm') !== -1 ? 'tone_warm' : 'tone_cool';
    if (g === 'scalp') {
      var sc = a.h_scalp || [];
      if (sc.indexOf('shedding') !== -1) return 'hairloss';
      if (sc.indexOf('flaky') !== -1) return 'scalp_flaky';
      if (sc.indexOf('sensitive') !== -1) return 'scalp_sensitive';
      if (sc.indexOf('oily') !== -1) return 'scalp_oily';
      if (sc.indexOf('sweat') !== -1) return 'scalp_sweat';
      return 'scalp_balanced';
    }
    return g;
  }
  /* which product concerns count as serving a goal */
  var GOAL_CONCERNS = {
    frizz: ['frizz'], hairloss: ['hair_loss'], curl_definition: ['curl_definition'], volume: ['volume'], dryness: ['dryness'],
    damage: ['damage'], color_fade: ['color_fade'], hold: ['hold'], shine: ['shine'], tone: ['brass_yellow', 'brass_warm_wanted'],
    scalp: ['oily_scalp', 'dry_flaky_scalp', 'oily_dandruff', 'sensitive_scalp', 'sweat', 'hair_loss']
  };
  function serves(p, g) {
    var keys = GOAL_CONCERNS[g] || [g];
    return (p.concerns || []).some(function (c) { return keys.indexOf(c) !== -1; });
  }
  function whyPicked(step, a) {
    a = withGoals(a);
    var p = step.p, label = (step.slot.label || '').toLowerCase();
    var s = '';
    if (a.area === 'hair') {
      var g1 = (a.h_goals || [])[0], g2 = (a.h_goals || [])[1];
      var d1 = GOAL_DOES[goalKey(a, g1)] || 'fits your hair';
      s = 'Chosen because it ' + d1;
      if (g2 && serves(p, g2)) s += ', and it ' + (GOAL_DOES[goalKey(a, g2)] || 'helps with your second goal') + ' at the same time';
      var mods = [];
      if (a.h_climate === 'humid' && (g1 === 'frizz' || g2 === 'frizz')) mods.push('sealing the strand against damp air');
      if ((a.h_strand === 'fine' || a.h_weighed === 'yes') && (p.weight || 0) <= 2) mods.push('light enough for hair that flattens easily');
      if ((a.h_color || []).indexOf('keratin') !== -1) mods.push('without disturbing your smoothing treatment');
      if ((a.h_color || []).indexOf('colored') !== -1 && (p.concerns || []).indexOf('color_fade') !== -1) mods.push('safe on coloured hair');
      if ((a.h_shed_scalp === 'sensitive' || (a.h_prefs || []).indexOf('pregnancy') !== -1) && (p.concerns || []).indexOf('sensitive_scalp') !== -1) mods.push('in the gentlest formula of the line');
      if (a.h_washfreq === 'daily' && (p.cadence || 'every-wash') === 'every-wash' && (p.roles || []).indexOf('cleanse') !== -1) mods.push('gentle enough for an everyday wash');
      if (mods.length) s += ', ' + mods.slice(0, 2).join(' and ');
      s += '.';
      var STEP_NAME = { 'cleanse': 'wash', 'alternating': 'treatment wash', 'weekly toning': 'weekly toning wash', 'condition': 'conditioning',
                        'weekly treatment': 'weekly treatment', 'scalp treatment': 'scalp treatment', 'leave-in': 'leave-in', 'style': 'styling',
                        'seal': 'sealing', 'before washing': 'pre-wash', 'lock in': 'finishing' };
      if (label) s += ' It is the ' + (STEP_NAME[label] || label) + ' step, the one the rest of the ritual is built around.';
      return s;
    }
    if (a.area === 'face') {
      var f1 = (a.f_concerns || [])[0], f2 = (a.f_concerns || [])[1];
      s = 'Chosen because it ' + (FACE_DOES[f1] || 'suits your skin');
      if (f2 && (p.concerns || []).indexOf(f2) !== -1) s += ', and it ' + FACE_DOES[f2] + ' at the same time';
      if (a.f_skin === 'sensitive' || a.f_ff === 'yes') s += ', with a formula that respects reactive skin';
      return s + '.';
    }
    if (a.area === 'body') {
      var b1 = (a.b_needs || [])[0], b2 = (a.b_needs || [])[1];
      s = 'Chosen because it ' + (BODY_DOES[b1] || 'cares for your skin');
      if (b2 && (p.concerns || []).indexOf(b2) !== -1) s += ', and it ' + BODY_DOES[b2] + ' too';
      return s + '.';
    }
    return 'Chosen as the heart of the shave: it softens the beard so the razor glides, and leaves the skin calm.';
  }

  /* add to cart the way the theme does: render sections, refresh the drawer, open it.
     attrs are cart attributes; Shopify copies them onto the order for attribution. */
  function addToCart(items, btn, doneLabel, attrs) {
    btn.disabled = true;
    var was = btn.textContent;
    btn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'header,cart-drawer,main-cart,footer' })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw 0;
        var sections = res.json.sections || {};
        try {
          var d = sections['cart-drawer'];
          if (d) {
            var doc = new DOMParser().parseFromString(d, 'text/html');
            var countEl = doc.querySelector('[data-cart-drawer-count]');
            var real = countEl ? Number(countEl.dataset.cartCountReal) : NaN;
            var foot = document.querySelector('[data-cart-drawer-footer]');
            if (foot) foot.classList.toggle('hidden', !(real > 0));
            ['[data-cart-drawer-carbon]', '[data-cart-drawer-total]'].forEach(function (sel) {
              var srcEl = doc.querySelector(sel), dstEl = document.querySelector(sel);
              if (srcEl && dstEl) dstEl.textContent = srcEl.textContent;
            });
            var srcC = doc.querySelector('[data-cart-drawer-content]');
            var dstC = document.querySelector('[data-cart-drawer-content]');
            if (srcC && dstC) dstC.innerHTML = srcC.innerHTML;
            document.dispatchEvent(new CustomEvent('cart:attachListener'));
          }
          var h = sections['header'];
          if (h) {
            var hd = new DOMParser().parseFromString(h, 'text/html');
            var cc = hd.querySelector('[data-cart-count]');
            if (cc) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cartCount: cc.textContent } }));
          }
        } catch (e) { /* drawer refresh is best effort */ }
        if (attrs) {
          fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          }).catch(function () {});
        }
        document.dispatchEvent(new CustomEvent('cart:open'));
        btn.textContent = doneLabel || 'Added';
        setTimeout(function () { btn.disabled = false; btn.textContent = was; }, 2500);
      })
      .catch(function () { btn.disabled = false; btn.textContent = was; });
  }

  QuizUI.prototype.renderResults = function () {
    var self = this;
    var wrap = this.root.closest('.rq-wrap');
    if (wrap) { wrap.classList.add('rq-started'); wrap.classList.add('rq-done'); }
    this.root.innerHTML = '<div class="rq-loading">Composing your ritual\u2026</div>';
    var result = this.engine.run(this.answers);
    resolveAvailability(result, this.engine).then(function (res) {
      if (self.gate(res)) return;
      function img(live, width) {
        var url = live.image || '';
        if (!url) return '';
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
      }

      var html = '<div class="rq-results">';
      html += '<div class="rq-results-head">';
      html += '<span class="rq-kicker">Your bespoke ritual</span>';
      html += '<h2 class="rq-results-title">' + ritualTitle(self.answers) + '</h2>';
      var sum = ritualSummary(self.answers);
      if (sum.length) html += '<div class="rq-summary">' + sum.join(' <span>\u00b7</span> ') + '</div>';
      html += '<div class="rq-head-rule"></div>';
      html += '</div>';
      if (!res.steps.length) {
        html += '<p class="rq-sub">We could not compose a ritual from these answers. Please <a href="/pages/contact">write to us</a> and we will pick for you personally.</p></div>';
        self.root.innerHTML = html; return;
      }
      /* the picks already reflect the answers; only the safety caution is worth a line here */
      if (res.notes.indexOf(REASONS.postpartum) !== -1) html += '<p class="rq-caution">' + REASONS.postpartum + '</p>';

      /* the ritual band numbers its own products (filled in once the band is known); the hero is named by its role */
      var stepNo = {};
      var HERO_EYEBROW = { 'cleanse': 'Your wash', 'alternating': 'Your treatment wash', 'weekly toning': 'Your toning wash', 'condition': 'Your conditioner',
        'weekly treatment': 'Your weekly treatment', 'scalp treatment': 'Your scalp treatment', 'leave-in': 'Your leave-in', 'style': 'Your styler',
        'seal': 'Your sealing step', 'before washing': 'Your pre-wash', 'lock in': 'Your finisher', 'treat': 'Your serum', 'moisturise': 'Your moisturiser',
        'eye contour': 'Your eye care', 'refresh': 'Your face mist', 'prepare': 'Your prep', 'shave': 'Your shave', 'repair': 'Your after-shave', 'beard care': 'Your beard care' };
      function heroEyebrow(step) {
        var l = (step.slot.label || '').toLowerCase();
        return HERO_EYEBROW[l] || (l === 'daily' || l === 'weekly' ? 'Your ' + l + ' essential' : 'Your first product');
      }

      function cadenceOf(step) {
        var c = step.cadenceLabel || CADENCE_LABEL[step.p.cadence || 'every-wash'] || '';
        if (c.indexOf('{{daily}}') !== -1) {
          var comp = res.steps.filter(function (x) { return x.companion; })[0];
          c = c.replace('{{daily}}', comp && comp.live ? comp.live.title : 'your everyday cleanse');
        }
        return c;
      }
      function blurbOf(step) {
        var b = BLURBS[step.p.handle] || '';
        if (step.layerOver) {
          var baseStep = res.steps.filter(function (x) { return x.p.handle === step.layerOver; })[0];
          var baseName = baseStep && baseStep.live ? baseStep.live.title : 'your styler';
          b = 'Layer this over ' + baseName + ' for hold that lasts days. Once dry, scrunch softly to free the movement.';
        }
        return b;
      }
      /* a stand-in for a sold-out pick says so in one quiet line under the blurb */
      function swapNote(step) {
        if (!step.substitutedFrom) return '';
        return '<p class="rq-swap">Standing in for ' + (step.originalTitle || 'our first choice') + ', sold out right now.</p>';
      }

      function mini(step, idx) {
        var p = step.p, live = step.live || {};
        var h = '<div class="rq-mini' + (step.tier === 'hero' ? ' is-hero' : '') + '" style="animation-delay:' + (idx * 100) + 'ms">';
        h += '<span class="rq-eyebrow">Step ' + stepNo[p.handle] + ' \u00b7 ' + step.slot.label + '</span>';
        h += '<a class="rq-mini-media" target="_blank" rel="noopener" href="' + (live.url || '#') + '">' + (live.image ? '<img src="' + img(live, 500) + '" alt="">' : '') + '</a>';
        h += '<a class="rq-mini-name" target="_blank" rel="noopener" href="' + (live.url || '#') + '">' + (live.title || p.handle) + '</a>';
        h += '<p class="rq-mini-blurb">' + blurbOf(step) + '</p>' + swapNote(step);
        h += '<div class="rq-meta">' + cadenceOf(step) + '</div>';
        h += '<div class="rq-mini-buy"><button type="button" class="rq-btn rq-add-one" data-variant="' + (live.variantId || '') + '">Add this only' + (live.price != null ? ' - ' + money(live.price) : '') + '</button></div>';
        h += '</div>';
        return h;
      }

      /* the hero card is built with slots; the product page fragment fills them in once fetched */
      function heroCard(step) {
        var p = step.p, live = step.live || {};
        var h = '<div class="rq-hero-card" data-handle="' + p.handle + '">';
        h += '<div class="rq-hero-top">';
        h += '<div class="rq-hero-media">';
        h += '<div class="rq-hero-visual" data-rq-slot="media"><a class="rq-hero-fallback" target="_blank" rel="noopener" href="' + (live.url || '#') + '">' + (live.image ? '<img src="' + img(live, 800) + '" loading="lazy" alt="">' : '') + '</a></div>';
        h += '<div class="rq-pills" data-rq-slot="badges" hidden></div>';
        h += '</div>';
        h += '<div class="rq-hero-body">';
        h += '<span class="rq-eyebrow">' + heroEyebrow(step) + '</span>';
        h += '<span class="rq-hero-line" data-rq-slot="line"></span>';
        h += '<a class="rq-hero-name" target="_blank" rel="noopener" href="' + (live.url || '#') + '">' + (live.title || p.handle) + '</a>';
        h += '<div class="rq-hero-price">' + (live.price != null ? money(live.price) : '') + '<span data-rq-slot="size"></span></div>';
        h += '<div class="rq-why"><span class="rq-why-k">Why we chose it for you</span><p>' + whyPicked(step, self.answers) + '</p></div>';
        /* on phones the long product copy folds away so the button stays on the first screen */
        h += '<button type="button" class="rq-details-toggle" aria-expanded="false" aria-controls="rq-hero-details">About this product</button>';
        h += '<div class="rq-hero-details" id="rq-hero-details">';
        h += '<p class="rq-hero-blurb" data-rq-slot="excerpt">' + blurbOf(step) + '</p>' + swapNote(step);
        h += '<div class="rq-howto" data-rq-slot="howto" hidden><span class="rq-why-k">How to use</span><div class="rq-howto-body"></div></div>';
        h += '</div>';
        h += '<div class="rq-meta">' + cadenceOf(step) + '</div>';
        h += '<div class="rq-hero-foot"><button type="button" class="rq-btn rq-hero-add" data-variant="' + (live.variantId || '') + '">Add to cart' + (live.price != null ? ' - ' + money(live.price) : '') + '</button></div>';
        h += '</div></div>';
        h += '<div class="rq-hero-cards" data-rq-slot="cards" hidden></div>';
        h += '</div>';
        return h;
      }

      /* pull excerpt, badges, how-to, the mobile carousel and the ingredient cards
         from the product page itself (section rendering API), so the hero reads
         like its PDP without duplicating content in the quiz */
      function enrichHero(card, step) {
        var live = step.live || {};
        if (!live.url) return;
        var url = live.url.split('?')[0] + '?section_id=ritual-quiz-hero';
        fetch(url).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var pdp = doc.querySelector('[data-rq-pdp]');
          if (!pdp) return;
          function slot(name) { return card.querySelector('[data-rq-slot="' + name + '"]'); }
          function textOf(sel) { var el = pdp.querySelector(sel); return el ? el.textContent.trim() : ''; }

          var line = textOf('[data-rq-line]'); if (line) slot('line').textContent = line;
          var size = textOf('[data-rq-size]'); if (size) slot('size').textContent = ' \u00b7 ' + size;
          /* the PDP excerpt sometimes opens with a rename note ("Previously known as X"), with or without a full stop */
          var excerpt = textOf('[data-rq-excerpt]')
            .replace(/^Previously known as [^.]*\.\s*/i, '')
            .replace(/^Previously known as (?:[A-Z][\w-]*\s)+?(?=[A-Z][a-z]* [a-z])/, '');
          if (excerpt) slot('excerpt').textContent = excerpt;
          var badges = pdp.querySelector('[data-rq-badges]');
          if (badges && badges.children.length) {
            var pills = slot('badges');
            pills.innerHTML = badges.innerHTML;
            pills.hidden = false;
            /* phones read name and reason first, badges after; desktop keeps them under the image */
            var why = card.querySelector('.rq-why'), mediaCol = card.querySelector('.rq-hero-media');
            var phone = window.matchMedia('(max-width: 767px)');
            function placePills() { if (phone.matches && why) why.insertAdjacentElement('afterend', pills); else mediaCol.appendChild(pills); }
            placePills();
            phone.addEventListener('change', placePills);
            /* the badges fade in one after the other as they scroll into view */
            Array.prototype.forEach.call(pills.children, function (el, i) { el.style.animationDelay = (i * 60) + 'ms'; });
            if ('IntersectionObserver' in window) {
              var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (en) { if (en.isIntersecting) { pills.classList.add('is-visible'); io.disconnect(); } });
              }, { threshold: 0.2 });
              io.observe(pills);
            } else pills.classList.add('is-visible');
          }
          var howto = pdp.querySelector('[data-rq-howto]');
          if (howto && howto.textContent.trim()) { slot('howto').querySelector('.rq-howto-body').innerHTML = howto.innerHTML; slot('howto').hidden = false; }
          var cards = pdp.querySelector('[data-rq-cards]');
          /* a single illustration looks orphaned, so the strip needs at least two */
          if (cards && cards.children.length >= 2) { slot('cards').innerHTML = cards.outerHTML; slot('cards').hidden = false; }

          var mobile = pdp.querySelector('[data-rq-media-mobile]');
          var desktop = pdp.querySelector('[data-rq-media-desktop]');
          if (mobile && desktop) {
            var media = slot('media');
            var link = live.url;
            desktop.innerHTML = '<a target="_blank" rel="noopener" href="' + link + '">' + desktop.innerHTML + '</a>';
            media.innerHTML = '';
            media.appendChild(mobile);
            media.appendChild(desktop);
            initHeroSlider(media.querySelector('[data-rq-slider]'));
          }
        }).catch(function () { /* the plain card stays */ });
      }
      function initHeroSlider(el) {
        if (!el || typeof window.Swiper === 'undefined') return;
        var mq = window.matchMedia('(max-width: 767px)');
        function start() {
          if (el.swiper) return;
          new window.Swiper(el, {
            slidesPerView: 'auto', centeredSlides: true, grabCursor: true, resistanceRatio: 0,
            pagination: { el: el.querySelector('.rqh-fraction'), type: 'fraction',
              renderFraction: function (c, t) { return '<span class="' + c + '"></span> / <span class="' + t + '"></span>'; } },
            navigation: { nextEl: el.querySelector('.rqh-next'), prevEl: el.querySelector('.rqh-prev') }
          });
        }
        if (mq.matches) start(); else mq.addEventListener('change', function h(e) { if (e.matches) { start(); mq.removeEventListener('change', h); } });
      }

      var hero = res.steps.filter(function (x) { return x.tier === 'hero'; });
      var base = res.steps.filter(function (x) { return x.tier === 'base'; });
      var heroName = hero.length && hero[0].live ? hero[0].live.title : 'your first product';
      function totalOf(steps) { return steps.reduce(function (t, s2) { return t + ((s2.live && s2.live.price) || 0); }, 0); }

      /* the ritual band shows every product in the order of use, hero included */
      res.steps.forEach(function (st, i) { stepNo[st.p.handle] = i + 1; });

      html += '<div class="rq-tier">';
      /* phones name the product in the tier title, since the card's own name sits below the carousel */
      var heroLive = hero.length ? (hero[0].live || {}) : {};
      html += '<div class="rq-tier-head"><span class="rq-kicker">01</span><h3 class="rq-tier-title"><span class="rq-desktop-only">Start here</span>'
        + '<span class="rq-mobile-only">Start with <a target="_blank" rel="noopener" href="' + (heroLive.url || '#') + '">' + heroName + '</a></span></h3>';
      html += '<p class="rq-tier-sub">If you take just one thing, make it this.</p></div>';
      html += hero.map(function (st) { return heroCard(st); }).join('');
      html += '</div>';
      /* the gift capture sits between the first product and the ritual */
      html += '<div class="rq-cta-slot"></div>';

      if (base.length) {
        html += '<div class="rq-tier">';
        html += '<div class="rq-tier-head"><span class="rq-kicker">02</span><h3 class="rq-tier-title">Make it a ritual</h3>';
        html += '<p class="rq-tier-sub">The full routine, in the order you use it, with ' + heroName + ' at its heart.</p></div>';
        html += '<div class="rq-tier-card">';
        html += '<div class="rq-tier-products">' + res.steps.map(mini).join('') + '</div>';
        html += '<div class="rq-tier-buy">';
        html += '<div class="rq-buy-text"><span class="rq-buy-kicker">The complete ritual</span>';
        html += '<span class="rq-buy-count">' + res.steps.length + ' products, ' + money(totalOf(res.steps)) + ' together. Everything above, nothing you do not need.</span></div>';
        html += '<button type="button" class="rq-btn rq-add-all">Add the ritual - ' + money(totalOf(res.steps)) + '</button>';
        html += '</div></div></div>';
      }

      html += '<div class="rq-all"><button type="button" class="rq-restart">Start over</button></div>';
      html += '</div>';
      self.root.innerHTML = html;
      var ctaSlot = self.root.querySelector('.rq-cta-slot');
      if (self.ctaTop && ctaSlot) { self.ctaTop.classList.add('rq-cta-compact'); ctaSlot.replaceWith(self.ctaTop); }
      else if (ctaSlot) ctaSlot.remove();
      hero.forEach(function (st) {
        var card = self.root.querySelector('.rq-hero-card[data-handle="' + st.p.handle + '"]');
        if (card) enrichHero(card, st);
      });
      self.live.textContent = 'Your ritual is ready. ' + ritualTitle(self.answers);
      var toggle = self.root.querySelector('.rq-details-toggle');
      if (toggle) toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = open ? 'Hide details' : 'About this product';
        self.root.querySelector('.rq-hero-details').classList.toggle('is-open', open);
      });
      /* land at the top of the results, title and gift capture first */
      var wrapEl = self.root.closest('.rq-wrap');
      var header = document.querySelector('header');
      var top = (wrapEl ? wrapEl.getBoundingClientRect().top + window.pageYOffset : 0) - (header ? header.getBoundingClientRect().height : 90);
      window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });

      function itemsOf(steps) {
        return steps.map(function (s2) { return s2.live && s2.live.variantId ? { id: s2.live.variantId, quantity: 1 } : null; }).filter(Boolean);
      }
      /* snapshot of the completed quiz, read by the Klaviyo captures */
      var toArr = function (v) { return !v ? [] : (Array.isArray(v) ? v : [v]); };
      var ga = withGoals(self.answers);
      var goals = toArr(ga.h_goals).concat(toArr(ga.f_concerns)).concat(toArr(ga.b_needs));
      window.__rqProfile = {
        quiz_completed: true,
        quiz_area: self.answers.area || '',
        quiz_goals: goals,
        quiz_hair_type: self.answers.h_pattern || '',
        quiz_hair_strand: self.answers.h_strand || '',
        quiz_wash_frequency: self.answers.h_washfreq || '',
        quiz_result: ritualTitle(self.answers),
        quiz_products: res.steps.map(function (s2) { return s2.p.handle; })
      };
      /* a light copy of the result, sent with an expert request so the reply can refer to it */
      window.__rqResult = {
        ritual_title: ritualTitle(self.answers),
        ritual_summary: ritualSummary(self.answers).join(' · '),
        products: res.steps.map(function (s2) {
          var lv = s2.live || {};
          return {
            name: String(lv.title || s2.p.handle).replace(/<[^>]*>/g, ''),
            handle: s2.p.handle,
            step: s2.slot.label,
            price: lv.price != null ? money(lv.price) : ''
          };
        })
      };
      /* the email given at the ritual step: the whole result goes to Klaviyo as one event,
         read by the email template of the 'Ritual Quiz Completed' flow.
         Links point at the domain the visitor is on. */
      var cfg = self.ritualCfg;
      if (cfg && self.pendingEmail) {
        var origin = cfg.origin || window.location.origin;
        var abs = function (u) { return !u ? '' : u.indexOf('//') === 0 ? 'https:' + u : /^https?:/.test(u) ? u : origin + u; };
        var plain = function (s) { return String(s || '').replace(/<[^>]*>/g, ''); };
        var heroStep = hero[0] || res.steps[0];
        var heroLiveR = heroStep.live || {};
        var cartItems = itemsOf(res.steps);
        var ritual = {
          ritual_title: ritualTitle(self.answers),
          ritual_summary: ritualSummary(self.answers).join(' · '),
          ritual_area: self.answers.area || '',
          ritual_goals: goals,
          ritual_count: res.steps.length,
          ritual_total: money(totalOf(res.steps)),
          hero: {
            name: plain(heroLiveR.title || heroStep.p.handle),
            url: abs(heroLiveR.url),
            image: abs(img(heroLiveR, 800)),
            handle: heroStep.p.handle,
            email_image: emailImg(heroStep.p.handle),
            eyebrow: heroEyebrow(heroStep),
            why: plain(whyPicked(heroStep, self.answers)),
            price: heroLiveR.price != null ? money(heroLiveR.price) : ''
          },
          products: res.steps.map(function (s2) {
            var lv = s2.live || {};
            return {
              name: plain(lv.title || s2.p.handle),
              url: abs(lv.url),
              image: abs(img(lv, 400)),
              handle: s2.p.handle,
              email_image: emailImg(s2.p.handle),
              step: 'Step ' + stepNo[s2.p.handle] + ' · ' + s2.slot.label,
              when: plain(cadenceOf(s2)),
              price: lv.price != null ? money(lv.price) : ''
            };
          }),
          cart_url: cartItems.length ? origin + '/cart/' + cartItems.map(function (i) { return i.id + ':1'; }).join(',') : origin + '/pages/ritual-quiz',
          quiz_url: origin + '/pages/ritual-quiz'
        };
        var email = self.pendingEmail;
        self.pendingEmail = null;
        /* a quiet status line under the title: sending, sent, or a retry */
        var note = document.createElement('p');
        note.className = 'rq-sent';
        note.setAttribute('role', 'status');
        var head = self.root.querySelector('.rq-results-head');
        if (head) head.appendChild(note);
        var send = function () {
          note.textContent = 'Sending your ritual to ' + email + '\u2026';
          sendRitual(cfg, email, ritual).then(function () {
            note.textContent = (cfg.done || 'Sent to [email].').replace('[email]', email);
          }).catch(function () {
            note.innerHTML = 'We could not send your ritual just now. <button type="button">Try again</button>';
            note.querySelector('button').addEventListener('click', send);
          });
        };
        send();
      }
      var cartAttrs = {
        'quiz': 'bespoke-ritual',
        'quiz_goal': goals.join(', '),
        'quiz_result': ritualTitle(self.answers) + ' (' + res.steps.map(function (s2) { return s2.p.handle; }).join(', ') + ')'
      };
      self.root.querySelectorAll('.rq-hero-add, .rq-add-one').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = parseInt(btn.getAttribute('data-variant'), 10);
          if (id) addToCart([{ id: id, quantity: 1 }], btn, 'Added', cartAttrs);
        });
      });
      self.root.querySelectorAll('.rq-add-all').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var items = itemsOf(res.steps);
          if (items.length) addToCart(items, btn, 'In your bag', cartAttrs);
        });
      });

      /* phones: a sticky bar keeps the buy action in reach once the hero button scrolls away */
      var heroAdd = self.root.querySelector('.rq-hero-add');
      var addAll = self.root.querySelector('.rq-add-all');
      if (heroAdd && 'IntersectionObserver' in window) {
        var bar = document.createElement('div');
        bar.className = 'rq-sticky';
        var many = res.steps.length > 1;
        bar.innerHTML = '<div class="rq-sticky-text"><strong>' + (many ? 'Your ritual' : heroName) + '</strong><span>' + (many ? res.steps.length + ' products · ' + money(totalOf(res.steps)) : money(totalOf(res.steps))) + '</span></div>'
          + '<button type="button" class="rq-btn rq-sticky-add">' + (many ? 'Add all' : 'Add to cart') + '</button>';
        document.body.appendChild(bar);
        bar.querySelector('.rq-sticky-add').addEventListener('click', function () {
          var items = itemsOf(res.steps);
          if (items.length) addToCart(items, bar.querySelector('.rq-sticky-add'), 'In your bag', cartAttrs);
        });
        var heroGone = false, allSeen = false;
        function sync() { bar.classList.toggle('is-on', heroGone && !allSeen); }
        new IntersectionObserver(function (en) {
          heroGone = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sync();
        }, { threshold: 0 }).observe(heroAdd);
        if (addAll) new IntersectionObserver(function (en) { allSeen = en[0].isIntersecting; sync(); }, { threshold: 0.5 }).observe(addAll);
      }
      self.root.querySelector('.rq-restart').addEventListener('click', function () {
        self.answers = {}; self.trail = []; 
        var w = self.root.closest('.rq-wrap');
        if (w) w.classList.remove('rq-done');
        self.render();
        self.scrollTop();
      });
    });
  };

  /* People we already know are subscribed: clicked a Klaviyo email link
     (_kx / utm_source=klaviyo in the URL) or signed up here before.
     Remembered in localStorage so the gift capture stays hidden on return visits. */
  function knownSubscriber() {
    try {
      var q = window.location.search;
      if (/[?&]_kx=/.test(q) || /[?&]utm_source=klaviyo/i.test(q)) localStorage.setItem('rq_subscribed', '1');
      return !!localStorage.getItem('rq_subscribed');
    } catch (e) { return false; }
  }

  /* email photos: each quiz product's photo, trimmed and multiplied onto the quiz card colour
     (#f1eee4), stored in Shopify Files as rq-email-<handle>.jpg. Email apps cannot blend images,
     so the look is baked in. Used at original size: a ?width= copy gains a colour profile and
     drifts off the card colour. Regenerate with scripts/quiz-email-images/process.py when
     products or their main photos change; handles missing here fall back to the product photo. */
  var EMAIL_IMG_BASE = 'https://cdn.shopify.com/s/files/1/0670/0679/1868/files/rq-email-';
  var EMAIL_IMG = {};
  ('after-sun-body-balm-new after-sun-hair-body-bath after-sun-hair-mask-copy afterglow-body-renovater age-better-face-mask blooming-gleam-face-cream bluemoon-hair-bath bluemoon-hair-mask bodifying-hair-renewer160ml boho-pomade-50ml bungee-fiber-50-ml calming-face-mask color-protection-hair-bath-240-ml color-protection-hair-mask color-protection-veil-160-ml comforting-scalp-oil curl-priming-cream-150ml curly-hair-bath curly-hair-co-wash curly-hair-combing-cream curly-hair-deep-mask curly-potion240ml enlivening-face-mist enriching-hair-conditioner everlasting-hair-booster extraordinary-body-amplifier-280 fabulous-body-oil fabulous-foot-cream face-beard-hydrating-cleanser-150-ml face-eye-energizing-texture-50-ml finest-fluid flowerfall-160-ml flux-potion-240ml fortifying-hair-bath fortifying-hair-lotion frequent-use-bath frequent-use-hair-conditioner glimmering-bond-100ml glossy-nectar160ml glowing-face-gommage hair-body-invigorating-wash-240-ml hydro-balance-scalp-gel-new lip-beard-salve-30-ml marvelous-skin-relief-face-cream miracle-eye-complex-20-ml moisturizing-hair-bath-new-1 moisturizing-hair-mask-new-1 molding-mist-240ml nebula next-day nurturing-drops50ml perfect-skin-cleansing-cream ph-hair-equalizer plant-mineral-refresh-36-gr precious-wax pure-balance-face-cream purifying-hair-bath-dry-scalps-new purifying-hair-bath-oily-scalp purifying-hair-lotion-dry-scalp purifying-hair-lotion-oily-scalps quick-glue100ml re-blooming-face-serum re-lieving-face-serum re-vitalizing-face-serum rebalancing-face-concentrate rebuildm-hair-bath rebuildm-hair-mask rebuildm-hair-serum refreshing-scalp-mask repairing-aftershave-balm-50-ml resurfacing-face-peel revitalizing-hair-lotion sculpting-mist-240ml sea-salt-spray-240ml sebum-balance-hair-bath-240-ml shaping-putty50ml shaping-treatment silver-steel-hair-bath-240-ml smooth-n-glow-hair-bath-240ml smooth-n-glow-hair-conditioner smooth-n-glow-hair-mask-160ml smooth-n-glow-serum-50ml smoothing-conditioner-240-ml smoothing-fluid-100-ml smoothing-hair-bath-240-ml softening-shave-cream-100-ml soothing-hair-bath-240-ml soothing-remedy-50-ml smoothing-cream-150-ml sublime-hair-milk-100ml sunlight-serum sunset-hour-hair-mask supreme-matt-paste50ml terso thermo-detangling-cloud-240ml velvet-body-fluid-50-ml volume-texture-hair-puff volumizing-hair-bath-copy volumizing-root-spray-160ml').split(' ').forEach(function (h) { EMAIL_IMG[h] = 1; });
  function emailImg(handle) { return EMAIL_IMG[handle] ? EMAIL_IMG_BASE + handle + '.jpg' : ''; }

  /* Klaviyo client API: public key only, safe in the browser. 202 means accepted. */
  function kPost(path, company, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok && r.status !== 202) throw 0; return r; });
  }
  function subscribeBody(source, list, email, props) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };
  }

  /* the ritual email: the result goes to Klaviyo as one event, then the email joins the
     newsletter list. Event first, so the welcome series (2 minute delay) already sees it
     and steps aside for the ritual flow. A retry after a failed subscription skips the event. */
  function sendRitual(cfg, email, ritual) {
    var props = { $source: cfg.source, quiz_capture: 'ritual' };
    if (window.__rqProfile) { for (var k in window.__rqProfile) props[k] = window.__rqProfile[k]; }
    var first = cfg.eventSent ? Promise.resolve() : kPost('events', cfg.company, {
      data: {
        type: 'event',
        attributes: {
          properties: ritual,
          metric: { data: { type: 'metric', attributes: { name: 'Ritual Quiz Completed' } } },
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
        }
      }
    }).then(function () { cfg.eventSent = true; });
    return first
      .then(function () { return kPost('subscriptions', cfg.company, subscribeBody(cfg.source, cfg.list, email, props)); })
      .then(function () { try { localStorage.setItem('rq_subscribed', '1'); } catch (e) {} });
  }

  /* the ritual step between the last question and the results: an email, or a clear skip.
     Not shown to people we already know as subscribers, nor twice in one visit. */
  QuizUI.prototype.gate = function (res) {
    var tpl = document.getElementById('rq-ritual-gate');
    if (!tpl || this.gatePassed || !res.steps.length || knownSubscriber()) return false;
    try { if (sessionStorage.getItem('rq_gate_skipped')) return false; } catch (e) {}
    var self = this, wrap = this.root.closest('.rq-wrap');
    this.root.innerHTML = '';
    this.root.appendChild(tpl.content.cloneNode(true));
    if (wrap) wrap.classList.add('rq-gating');
    var n = res.steps.length;
    var title = this.root.querySelector('.rq-gate-title');
    var t = title.getAttribute('data-title') || 'Email me my ritual';
    title.textContent = n > 1 ? t.replace('[steps]', n) : t.replace(/\[steps\]-step\s*/, '').replace('[steps]', '1');
    this.root.querySelector('.rq-gate-result').textContent = ritualTitle(this.answers);
    var form = this.root.querySelector('form.rq-ritual-form');
    this.ritualCfg = {
      company: form.getAttribute('data-company'), list: form.getAttribute('data-list'),
      source: form.getAttribute('data-source'), origin: form.getAttribute('data-origin'),
      done: form.getAttribute('data-done')
    };
    function go(email) {
      self.gatePassed = true;
      self.pendingEmail = email || null;
      if (wrap) wrap.classList.remove('rq-gating');
      self.renderResults();
    }
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var connected = self.ritualCfg.company && self.ritualCfg.list;
      go(connected ? form.querySelector('input[name=email]').value.trim() : null);
    });
    this.root.querySelector('.rq-gate-skip').addEventListener('click', function () {
      try { sessionStorage.setItem('rq_gate_skipped', '1'); } catch (e) {}
      go(null);
    });
    this.live.textContent = 'Your ritual is ready. ' + title.textContent + ', or skip to see it now.';
    this.scrollTop();
    return true;
  };

  /* Klaviyo captures: client subscription API, consent recorded by Klaviyo */
  function bindKlaviyoForms() {
    document.querySelectorAll('form.rq-klaviyo').forEach(function (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var company = form.getAttribute('data-company');
        var list = form.getAttribute('data-list');
        var btn = form.querySelector('button[type=submit]');
        var emailEl = form.querySelector('input[name=email]');
        var msgEl = form.querySelector('textarea[name=message]');
        if (!company || !list) {
          btn.textContent = 'Sign-up is not connected yet';
          setTimeout(function () { btn.textContent = form.classList.contains('rq-cta-sent') ? btn.textContent : (msgEl ? 'Ask our experts' : 'Sign up'); }, 2500);
          return;
        }
        var props = { $source: form.getAttribute('data-source'), quiz_capture: form.getAttribute('data-tag') };
        if (window.__rqProfile) { for (var k in window.__rqProfile) props[k] = window.__rqProfile[k]; }
        if (msgEl && msgEl.value) props.expert_request = msgEl.value.slice(0, 1000);
        btn.disabled = true;
        var was = btn.textContent;
        btn.textContent = 'One moment\u2026';
        /* an expert request is also its own 'Expert Request' event, so every question is kept
           (the profile property holds only the latest) and a flow can acknowledge it.
           A retry after a failed subscription skips the event. */
        var first = Promise.resolve();
        if (msgEl && msgEl.value && !form.__rqEventSent) {
          var req = { message: msgEl.value.slice(0, 2000), page: window.location.href.split('#')[0] };
          if (window.__rqProfile) { for (var q in window.__rqProfile) { if (q !== 'quiz_completed') req[q] = window.__rqProfile[q]; } }
          if (window.__rqResult) { for (var r in window.__rqResult) req[r] = window.__rqResult[r]; }
          first = kPost('events', company, {
            data: {
              type: 'event',
              attributes: {
                properties: req,
                metric: { data: { type: 'metric', attributes: { name: 'Expert Request' } } },
                profile: { data: { type: 'profile', attributes: { email: emailEl.value, properties: props } } }
              }
            }
          }).then(function () { form.__rqEventSent = true; });
        }
        first.then(function () {
          return kPost('subscriptions', company, subscribeBody(form.getAttribute('data-source'), list, emailEl.value, props));
        }).then(function () {
          if (form.getAttribute('data-tag') === 'gift') { try { localStorage.setItem('rq_subscribed', '1'); } catch (e) {} }
          form.innerHTML = '<p class="rq-cta-done">' + (msgEl
            ? 'Thank you. An Oway expert will reply by email within a week.'
            : 'Thank you. Check your email to see how to redeem your gift.') + '</p>';
        }).catch(function () {
          btn.disabled = false; btn.textContent = was;
          emailEl.setCustomValidity('Something went wrong. Please try again.');
          emailEl.reportValidity();
          setTimeout(function () { emailEl.setCustomValidity(''); }, 2500);
        });
      });
    });
  }

  /* boot */
  function boot() {
    if (knownSubscriber()) {
      var gift = document.querySelector('.rq-cta-top');
      if (gift) gift.remove();
    }
    bindKlaviyoForms();
    var root = document.getElementById('ritual-quiz');
    if (!root) return;
    fetch(root.getAttribute('data-src'))
      .then(function (r) { return r.json(); })
      .then(function (data) { new QuizUI(root, data); })
      .catch(function () { root.innerHTML = '<p class="rq-sub">The quiz could not load. Please refresh the page.</p>'; });
  }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  }

  /* expose for tests */
  if (typeof module !== 'undefined' && module.exports) module.exports = { Engine: Engine, QUESTIONS: QUESTIONS, ritualTitle: ritualTitle, whyPicked: whyPicked, withGoals: withGoals };
})();
